import React, { useEffect } from 'react'
import InputField, { InputFieldProps } from '../inputField'
import Icon from '../../elementals/icon'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)
const FONT_LINK_ID = 'corinthia-google-font'

export interface SignatureInputFieldProps extends InputFieldProps {} // eslint-disable-line @typescript-eslint/no-empty-interface

const SignatureInputField: React.FC<SignatureInputFieldProps> = props => {
  const { className, ...rest } = props

  useEffect(() => {
    if (!document.getElementById(FONT_LINK_ID)) {
      const link = document.createElement('link')
      link.id = FONT_LINK_ID
      link.rel = 'stylesheet'
      link.href =
        'https://fonts.googleapis.com/css2?family=Corinthia:wght@400;700&display=swap'
      document.head.appendChild(link)
    }
  }, [])

  return (
    <InputField {...rest} className={cx('signature-field', className)}>
      <Icon
        key='icon'
        name='xmark'
        iconStyle='solid'
        size='small'
        color='grayMedium'
        className={cx('x-icon')}
      />
      <div className={cx('input-wrapper')} key='input-wrapper'>
        <div className={cx('underline')} />
        <input aria-label={`${rest.elmId}_input`} />
      </div>
    </InputField>
  )
}

export default SignatureInputField
